export default __webpack_public_path__ + "static/media/mass_street_alley.8aa26484.jpg";